import {useCallback, useState} from 'react';

import {ModalityCodeEnum} from 'domain/usecases';
import {useRefundRequest} from '../../../hooks';
import {useGetRefundProfessionalCouncilsQuery} from '../queries/useGetRefundProfessionalCouncilsQuery';
import {useProfessionalCouncilOptionsStore} from '../store/useProfessionalCouncilOptionsStore';

export function useGetCouncilTypes() {
	const {
		atoms: {treatmentData},
	} = useRefundRequest();
	const [open, setOpen] = useState(false);
	const [fetchError, setFetchError] = useState(false);
	const professionalCouncilOptionsState = useProfessionalCouncilOptionsStore(
		state => state.options,
	);
	const setProfessionalCouncilOptionsState = useProfessionalCouncilOptionsStore(
		state => state.setOptions,
	);

	const MEDICAL_APPOINTMENT_MODALITY =
		treatmentData.modalityCode.toString() === ModalityCodeEnum.MEDICAL_APPOINTMENT;

	const {data, refetch, isLoading} = useGetRefundProfessionalCouncilsQuery({
		'modality-code': MEDICAL_APPOINTMENT_MODALITY ? treatmentData.modalityCode : undefined,
	});
	const loadingList = open && isLoading;

	const handleOpen = useCallback(async () => {
		setOpen(true);
		if (!data) {
			const response = await refetch();
			if (response.isError) {
				setFetchError(true);
				return;
			}
			setProfessionalCouncilOptionsState(response.data ?? []);
			return;
		}
		setProfessionalCouncilOptionsState(data ?? []);
	}, [data]);

	const handleClose = useCallback(async () => {
		setOpen(false);
	}, []);

	const handleRefresh = useCallback(async () => {
		setFetchError(false);
	}, []);

	return {
		loadingList,
		options: professionalCouncilOptionsState,
		open,
		handleOpen,
		handleClose,
		fetchError,
		setFetchError,
		handleRefresh,
	};
}
